import React from "react";

export function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="11"
      fill="none"
      viewBox="0 0 13 11"
    >
      <path
        fill="#0767F4"
        d="M12.808 8.523L8.045.816C7.575.045 6.457-.23 5.635.21c-.295.165-.53.386-.648.606L.225 8.523c-.47.77-.177 1.816.646 2.257.294.165.588.22.882.22h9.467c1 0 1.764-.77 1.764-1.652.06-.33-.058-.605-.176-.825zm-6.292.275c-.353 0-.588-.22-.588-.55 0-.33.235-.551.588-.551s.588.22.588.55c0 .33-.235.551-.588.551zm.588-2.753c0 .33-.235.551-.588.551s-.588-.22-.588-.55V3.842c0-.33.235-.55.588-.55s.588.22.588.55v2.202z"
      ></path>
    </svg>
  );
}
